import { render, staticRenderFns } from "./storeRecevieRecord.vue?vue&type=template&id=47296696"
import script from "./storeRecevieRecord.vue?vue&type=script&lang=js"
export * from "./storeRecevieRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports